import useAsyncData from "../../../../hooks/use-async-data";
import orderOptimizerService from "../../order-optimizer.service";
import OrderOptimizerDetailsCargo from "./order-optimizer-details-cargo";
import OrderOptimizerDetailsCargoParams from "./order-optimizer-details-cargo-params";

const useOrderOptimizerDetailsCargo = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderOptimizerDetailsCargo | null>(null);

  const load = async (
    params: OrderOptimizerDetailsCargoParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const orderOptimizerDetailsCargo: OrderOptimizerDetailsCargo =
        await orderOptimizerService.getCargoDetails(params, signal);

      setData(orderOptimizerDetailsCargo);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsError(false);
    setIsLoading(true);
    setData(null);
  };

  return {
    data,
    isError,
    isLoading,
    load,
    reset,
  };
};

export default useOrderOptimizerDetailsCargo;
